import { FontType } from '../Typography/types';
import { TagSizes } from './types';

export const TAG_SIZE_TYPOGRAPHY_MAP: Record<TagSizes, FontType> = {
    sm: 'h6',
    md: 'h5',
};
